import { render, staticRenderFns } from "./AIChatbotImportModal.vue?vue&type=template&id=53526c94&scoped=true"
import script from "./AIChatbotImportModal.vue?vue&type=script&lang=js"
export * from "./AIChatbotImportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53526c94",
  null
  
)

export default component.exports